import { DAY_RANGE, EMPLOYEE_VIEW, MONTH_RANGE, type ViewRange, type ViewType } from '@/scheduler/util/view';
import { preserveReferences } from '@/shared/util/memo';
import type { WiwState } from '@/store';

import { createSelector } from '@reduxjs/toolkit';

export const getCurrentRange = (state: WiwState) => state.scheduler.get('range') as ViewRange;

/**
 * NOTE: The scheduler view should be accessed through this selector, not directly from the store.
 *
 * The currentRange supersedes the selected view while in month or day ranges. There's only one type of view while in
 * these ranges, so we force that view for day and month views. The state is not actually updated so that when the user
 * switches back to week range, they will still be in whatever view they had previously selected.
 */
export const getCurrentView = createSelector(
  [state => state.scheduler.get('view'), getCurrentRange],
  (currentView: ViewType, currentRange) => {
    return currentRange === MONTH_RANGE || currentRange === DAY_RANGE ? EMPLOYEE_VIEW : currentView;
  },
);

export const getCurrentViewMode = createSelector(
  [getCurrentView, getCurrentRange],
  preserveReferences((view, range) => ({
    view: view,
    range: range,
  })),
);
